"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useValueRef;

var _react = require("react");

function useValueRef(value) {
  var ref = (0, _react.useRef)();
  var readOnlyRef = (0, _react.useMemo)(function () {
    return Object.create({}, {
      current: {
        get: function get() {
          return ref.current;
        }
      }
    });
  }, []);
  ref.current = value;
  return readOnlyRef;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VWYWx1ZVJlZiIsInZhbHVlIiwicmVmIiwidXNlUmVmIiwicmVhZE9ubHlSZWYiLCJ1c2VNZW1vIiwiT2JqZWN0IiwiY3JlYXRlIiwiY3VycmVudCIsImdldCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL2ludGVybmFsL3VzZVZhbHVlUmVmLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlZk9iamVjdCwgdXNlTWVtbywgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VWYWx1ZVJlZjxUPih2YWx1ZTogVCk6IFJlZk9iamVjdDxUPiB7XG4gIGNvbnN0IHJlZiA9IHVzZVJlZjxUPigpO1xuICBjb25zdCByZWFkT25seVJlZiA9IHVzZU1lbW8oXG4gICAgKCkgPT5cbiAgICAgIE9iamVjdC5jcmVhdGUoXG4gICAgICAgIHt9LFxuICAgICAgICB7XG4gICAgICAgICAgY3VycmVudDoge1xuICAgICAgICAgICAgZ2V0OiAoKSA9PiByZWYuY3VycmVudFxuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgKSxcbiAgICBbXVxuICApO1xuXG4gIHJlZi5jdXJyZW50ID0gdmFsdWU7XG5cbiAgcmV0dXJuIHJlYWRPbmx5UmVmO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRWUsU0FBU0EsV0FBVCxDQUF3QkMsS0FBeEIsRUFBZ0Q7RUFDN0QsSUFBTUMsR0FBRyxHQUFHLElBQUFDLGFBQUEsR0FBWjtFQUNBLElBQU1DLFdBQVcsR0FBRyxJQUFBQyxjQUFBLEVBQ2xCO0lBQUEsT0FDRUMsTUFBTSxDQUFDQyxNQUFQLENBQ0UsRUFERixFQUVFO01BQ0VDLE9BQU8sRUFBRTtRQUNQQyxHQUFHLEVBQUU7VUFBQSxPQUFNUCxHQUFHLENBQUNNLE9BQVY7UUFBQTtNQURFO0lBRFgsQ0FGRixDQURGO0VBQUEsQ0FEa0IsRUFVbEIsRUFWa0IsQ0FBcEI7RUFhQU4sR0FBRyxDQUFDTSxPQUFKLEdBQWNQLEtBQWQ7RUFFQSxPQUFPRyxXQUFQO0FBQ0QifQ==